import * as React from 'react';
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { RcFile } from 'antd/lib/upload';

type Props = {
    value?: File | null;
    previewUrl?: string;
    disabled?: boolean;
    onChange: (file: File | null) => void;
};

const allowedFileTypes = ['image/jpeg', 'image/png', 'image/webp'];
const maxFileSizeBytes = 2 * 1024 * 1024;

const ImageUpload: React.FC<Props> = ({ value, previewUrl, disabled, onChange }) => {
    const [localPreviewUrl, setLocalPreviewUrl] = React.useState<string | undefined>(previewUrl);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        let objectUrl: string | undefined;

        if (value) {
            objectUrl = URL.createObjectURL(value);
            setLocalPreviewUrl(objectUrl);
        } else {
            setLocalPreviewUrl(previewUrl);
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [previewUrl, value]);

    const beforeUpload = (file: RcFile) => {
        if (!allowedFileTypes.includes(file.type)) {
            message.error('Only JPEG, PNG, and WebP images are allowed.');
            return false;
        }

        if (file.size > maxFileSizeBytes) {
            message.error('Image size cannot exceed 2 MB.');
            return false;
        }

        setIsLoading(true);
        onChange(file);
        setIsLoading(false);

        return false;
    };

    const uploadButton = (
        <div>
            {isLoading ? <LoadingOutlined /> : <PlusOutlined />}
            <div className="ant-upload-text">Upload</div>
        </div>
    );

    return (
        <Upload
            accept=".jpeg,.jpg,.png,.webp"
            name="shortcut-image"
            listType="picture-card"
            className="icon-uploader"
            showUploadList={false}
            disabled={disabled}
            beforeUpload={beforeUpload}
        >
            {localPreviewUrl ? <img src={localPreviewUrl} alt="shortcut" /> : uploadButton}
        </Upload>
    );
};

export default ImageUpload;
